export default __webpack_public_path__ + "115feb0bbb159300e9f5e16e4da910ef.png";